

const LOCAL_DATA_URL = process.env && process.env.REACT_APP_LOCAL_DATA_URL || 'https://cbpgroup.in';
const API_URL = process.env && process.env.REACT_APP_API_URL || 'https://ops.cbpgroup.in/api/method';
// const LOCAL_DATA_URL = 'https://cbp.datagrid.co.in';
// const API_URL = 'https://ops.cbpgroup.in/api/method';

const username = (process.env && process.env.REACT_APP_USERNAME) || '';
const password = (process.env && process.env.REACT_APP_PASSWORD) || '';
const authHeader = 'Basic ' + btoa(username + ':' + password);

const CACHE_DURATION = 60 * 60 * 1000; // 1 hour
const memoryCache = {};

const getFromCache = (key) => {
  try {
    const cached = memoryCache[key];
    if (!cached) return null;
    const { data, timestamp } = cached;
    if (Date.now() - timestamp > CACHE_DURATION) {
      delete memoryCache[key];
      return null;
    }
    return data;
  } catch (e) {
    return null;
  }
};

const saveToCache = (key, data) => {
  try {
    memoryCache[key] = { data, timestamp: Date.now() };
  } catch (e) {
    console.warn('Cache save failed', e);
  }
};

export const fetchLeads = async ({ page, type }) => {
  console.log(page, type);
  // const res = await fetch(`${LOCAL_DATA_URL}/db/leads.json`);
  const headers = {
    'Authorization': authHeader,
    'Accept': 'application/json',
  };

  // console.log('[FetchLeads] Request →', { username, password, authHeader, API_URL, LOCAL_DATA_URL });

  let data;

  const res = await fetch(`${API_URL}/erpnext.assets.doctype.deals.deals.get_all_deals?type=${type}`, {
    method: 'GET',
    headers,
    cache: 'no-store'
  });

  // console.log('[FetchLeads] Request →', { headers });

  if (res.ok) {
    data = await res.json();
  } else {
    console.error("ERPNext API Error:", res.status, res.statusText);
  }

  return data.message;
};

export const fetchTeam = async () => {
  const cacheKey = 'cbp_team_data';
  const cachedData = getFromCache(cacheKey);
  if (cachedData) return cachedData;

  const res = await fetch(`${LOCAL_DATA_URL}/db/team.json`);
  const data = await res.json();
  saveToCache(cacheKey, data);
  return data;
};

export const fetchAssets = async () => {
  const cacheKey = 'cbp_assets_data';
  const cachedData = getFromCache(cacheKey);
  if (cachedData) return cachedData;

  const res = await fetch(`${LOCAL_DATA_URL}/db/assetClasses.json`);
  const data = await res.json();
  const filteredData = data.filter(({ is_deleted }) => !is_deleted);
  saveToCache(cacheKey, filteredData);
  return filteredData;
};

export const fetchTestimonials = async () => {
  const cacheKey = 'cbp_testimonials_data';
  const cachedData = getFromCache(cacheKey);
  if (cachedData) return cachedData;

  const res = await fetch(`${LOCAL_DATA_URL}/db/testimonials.json`);
  const data = await res.json();
  saveToCache(cacheKey, data);
  return data;
};

export const fetchFaqs = async () => {
  const cacheKey = 'cbp_faqs_data';
  const cachedData = getFromCache(cacheKey);
  if (cachedData) return cachedData;

  const res = await fetch(`${LOCAL_DATA_URL}/db/faqs.json`);
  const data = await res.json();
  const filteredData = data.filter(({ is_deleted }) => !is_deleted);
  saveToCache(cacheKey, filteredData);
  return filteredData;
};

export const fetchCbp = async () => {
  const cacheKey = 'cbp_cbp_data';
  const cachedData = getFromCache(cacheKey);
  if (cachedData) return cachedData;

  const res = await fetch(`${LOCAL_DATA_URL}/db/cbp.json`);
  const data = await res.json();
  saveToCache(cacheKey, data);
  return data;
};

// New API endpoint for Member Registration Form
export const submitMemberRegistration = async (formData) => {
  try {

    const body = new FormData();
    Object.keys(formData).forEach((key) => {
      // Skip documentsAttached as requested (no boolean flags needed in API)
      if (key === 'documentsAttached') {
        return;
      }

      if (key === 'uploadedFiles') {
        const files = formData[key];
        if (files) {
          Object.keys(files).forEach((fileKey) => {
            if (files[fileKey]) {
              body.append(fileKey, files[fileKey]);
            }
          });
        }
      } else if (['declaration_1', 'declaration_2', 'declaration_3', 'check_ztpjp'].includes(key)) {
        // Convert boolean fields to 0 or 1
        body.append(key, formData[key] ? '1' : '0');
      } else if (['dob', 'date', 'fee_date', 'approved_date'].includes(key) && formData[key]) {
        // Convert DD-MM-YYYY to YYYY-MM-DD
        const parts = formData[key].split('-');
        if (parts.length === 3) {
          body.append(key, `${parts[2]}-${parts[1]}-${parts[0]}`);
        } else {
          body.append(key, formData[key]);
        }
      } else {
        const value = formData[key];
        if (Array.isArray(value) || (typeof value === 'object' && value !== null)) {
          body.append(key, JSON.stringify(value));
        } else if (value !== null && value !== undefined) {
          body.append(key, value);
        }
      }
    });

    const headers = {
      'Authorization': authHeader,
      'Accept': 'application/json',
    };

    // console.log('[MemberRegistration] submitting...', { headers, body: Array.from(body.entries()) });

    const res = await fetch(`${API_URL}/erpnext.assets.doctype.membership_details.membership_details.add_membership_details`, {
      method: 'POST',
      headers,
      body
    });

    console.log('[MemberRegistration] Response ←', { status: res.status, ok: res.ok });

    return res;
    // return true;
  } catch (err) {
    console.error('[MemberRegistration] Error ✖', err);
    throw err;
  }
};

export const searchDeals = async (searchTerm) => {

  try {
    const res = await fetch(`${API_URL}/erpnext.assets.doctype.deals.deals.search_deals?search_term=${encodeURIComponent(searchTerm)}`, {
      method: 'GET',
      headers: {
        'Authorization': authHeader,
        'Accept': 'application/json',
        // cache: 'no-store'
      }
    });

    if (res.ok) {
      const data = await res.json();
      return data.message || [];
    } else {
      console.error("Search Deals API Error:", res.status, res.statusText);
      return [];
    }
  } catch (err) {
    console.error("Search Deals API Exception:", err);
    return [];
  }
};

export const getSearchHistory = async () => {

  try {
    const res = await fetch(`${API_URL}/erpnext.assets.doctype.deals.deals.get_search_history`, {
      method: 'GET',
      headers: {
        'Authorization': authHeader,
        'Accept': 'application/json',
        // cache: 'no-store'
      }
    });

    if (res.ok) {
      const data = await res.json();
      return data.message || [];
    } else {
      console.error("Get Search History API Error:", res.status, res.statusText);
      return [];
    }
  } catch (err) {
    console.error("Get Search History API Exception:", err);
    return [];
  }
};

export const saveInvestorRegistrationDetails = async (formData) => {
  try {
    const body = new FormData();
    Object.keys(formData).forEach((key) => {
      const value = formData[key];
      if (Array.isArray(value) || (typeof value === 'object' && value !== null)) {
        body.append(key, JSON.stringify(value));
      } else if (value !== null && value !== undefined) {
        body.append(key, value);
      }
    });

    const headers = {
      'Authorization': authHeader,
      'Accept': 'application/json',
    };

    const res = await fetch(`${API_URL}/erpnext.assets.doctype.investor_registration_details.investor_registration_details.save_investor_registration_details`, {
      method: 'POST',
      headers,
      body
    });

    console.log('[saveInvestorRegistrationDetails] Response ←', { status: res.status, ok: res.ok });

    return res;
  } catch (err) {
    console.error('[PrimaryRegistration] Error ✖', err);
    throw err;
  }
};

export const getInvestorRegistrationDetails = async (memberId) => {
  try {
    const headers = {
      'Authorization': authHeader,
      'Accept': 'application/json',
    };

    // Assumed endpoint based on standard pattern or user's implication
    // Using a likely custom method or generic get
    // Since user said "only need member(contact_us_id)={}", I assume a custom method might exist or I query by name
    const res = await fetch(`${API_URL}/erpnext.assets.doctype.investor_registration_details.investor_registration_details.get_investor_registration_details?inv_reg_id=${memberId}`, {
      method: 'GET',
      headers,
      cache: 'no-store'
    });

    if (res.ok) {
      const data = await res.json();
      return data.message;
    } else {
      console.error("Get Member Details API Error:", res.status, res.statusText);
      return null;
    }
  } catch (err) {
    console.error('[getInvestorRegistrationDetails] Error ✖', err);
    return null;
  }
};

export const saveMemberRegistrationDetails = async (formData) => {
  try {
    const body = new FormData();
    Object.keys(formData).forEach((key) => {
      const value = formData[key];
      if (Array.isArray(value) || (typeof value === 'object' && value !== null)) {
        body.append(key, JSON.stringify(value));
      } else if (value !== null && value !== undefined) {
        body.append(key, value);
      }
    });

    const headers = {
      'Authorization': authHeader,
      'Accept': 'application/json',
    };

    const res = await fetch(`${API_URL}/erpnext.assets.doctype.member_registration_details.member_registration_details.save_member_registration_details`, {
      method: 'POST',
      headers,
      body
    });

    console.log('[saveMemberRegistrationDetails] Response ←', { status: res.status, ok: res.ok });

    return res;
  } catch (err) {
    console.error('[saveMemberRegistrationDetails] Error ✖', err);
    throw err;
  }
};

export const getMemberRegistrationDetails = async (memberId) => {
  try {
    const headers = {
      'Authorization': authHeader,
      'Accept': 'application/json',
    };

    // Assumed endpoint based on standard pattern or user's implication
    // Using a likely custom method or generic get
    // Since user said "only need member(contact_us_id)={}", I assume a custom method might exist or I query by name
    const res = await fetch(`${API_URL}/erpnext.assets.doctype.member_registration_details.member_registration_details.get_member_registration_details?mem_reg_id=${memberId}`, {
      method: 'GET',
      headers,
      cache: 'no-store'
    });

    if (res.ok) {
      const data = await res.json();
      return data.message;
    } else {
      console.error("Get Member Details API Error:", res.status, res.statusText);
      return null;
    }
  } catch (err) {
    console.error('[getMemberRegistrationDetails] Error ✖', err);
    return null;
  }
};

export const submitBecomeMember = async (formData) => {
  try {
    const url = `https://cbp-api.datagrid.co.in/become_member.php`;
    const headers = {
      'Content-Type': 'application/json',
    };
    const body = JSON.stringify(formData);

    // console.log('[BecomeMember] Request →', { url, headers, bodyParsed: formData, body });

    const res = await fetch(url, {
      method: 'POST',
      headers,
      body,
    });

    console.log('[BecomeMember] Response ←', { status: res.status, ok: res.ok });

    return res;
  } catch (err) {
    console.error('[BecomeMember] Error ✖', err);
    throw err;
  }
};
